function accounts(backendAxiosInstance) {
  async function acknowledge(acknowledgeData) {
    return backendAxiosInstance.post(
      "/customer/v1/legal-terms/acknowledgment",
      acknowledgeData
    );
  }
  async function checkEligibility(verifyLegal = true) {
    return backendAxiosInstance.get(
      "/customer/v1/legal-terms",
      {
        params: {
          verifyLegal
        }
      }
    );
  }
  return {
    acknowledge,
    checkEligibility
  };
}

export { accounts as default };
//# sourceMappingURL=legal.js.map
